<template>
  <div class="sign">
    <mt-header title="签署文件">
      <mt-button icon="back" slot="left" @click="goback">返回</mt-button>
      <a @click="backhome()" slot="left" class="backhome">关闭</a>
      <a @click="next()" slot="right">
        下一步
      </a>
    </mt-header>

    <div class="content">
      <div class="pagestyle">{{currentPage}}/{{dataList.length}}</div>
      <div class="unipage">
        <a @click="pagePrev()"><em class="one"></em></a>
         <a class="line-bnone" @click="pageNext()"><em class="four"></em></a>
      </div>

      <div class="abscont" v-for="(item,index) in dataList" :key=index>
          <img :id="item.signPage" v-show="currentPage==index+1" class="signcontract" :src="'/api/'+getSrc(item.src)">
          <div v-show="item.signed && currentPage==index+1" class="signature" :id="signature+item.signPage">
            <div class="deldiv" @click="closeSignature(item,index)">
              <img src="/static/img/contract/del.png">
            </div>
            <img class="sjimg" src="/static/img/contract/signdel.png">
            <img class="signdiv" @touchmove="vtouchmove()" @touchstart="vtouchstart()"
            @touchend="vtouchend()" :src="signatureImg">
          </div>
          <div class="signbottom" v-show="currentPage==index+1">
            <div class="signflex" @click="addSignature(item,index)">
              <img class="signimg" src="/static/img/contract/signimg1.png">
              <div>默认签章</div>
            </div>
            <div class="signflex" @click="toSignature()">
              <img src="/static/img/contract/signimg2.png">
              <div>手写签名</div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { MessageBox, Indicator } from 'mint-ui';
import cheader from '@/components/header';
import { signFlowInitApi, signCheckStatusApi, signCertificateApplyApi } from '@/api/common';
import { mapState } from 'vuex';
export default {
  data () {
    return {
      temp:'',
      cid:this.$route.query.cid,
      dataList:'',
      pushList:[],
      currentPage:'1',
      signature:'signature',
      rooturl:'',
      flag : false,
      registerType:'',
      registerSignId:'',
      defaultSignId:'',
      issign:'false',
      signatureImg:'',
      fileType:'',
      cur : {
        x:0,
        y:0
      },
      dx:0,dy:0,x:0,y:0,boxX:0,boxY:0
    }
  },
  computed: {
    ...mapState({
      approveStatus: state => state.App.approveStatus,
    })
  },
  mounted(){
    this.showSginContract();
  },
  methods: {
    getSrc:function(src){
      return src+"?sn="+new Date();
    },
    initSign:function(){
      var that = this;
      var fls = false;
    //   that.$http.post(
    //       domain("_isSigned"),
    //       {
    //         'contractId':this.cid
    //       }
    //   )
    //   .then(function(response){
    //       if(response.data.code == "1"){
    //       	that.$router.push("/main");
    //       	fls = true;
    //       }else{
    //       }
    //       },function(error){
    //         console.log(error);
    //   });
      if(fls){
      	return;
      }
    //   that.$http.post(
    //       domain("_judge4"),
    //       {
    //         'contractId':this.cid
    //       }
    //   )
    //   .then(function(response){
    //       if(response.data.code == "0"){
    //         that.fileType = response.data.data.fileType;
    //         that.showSgincgx();
    //       }else if(response.data.code == "1"){
    //          that.showSginContract();
    //       }else if(response.data.code == '5'){
    //              MessageBox.confirm('', { 
    //              message: '套餐余额不足，请先购买套餐后进行签署！', 
    //              title: '提示', 
    //              confirmButtonText: '去购买', 
    //              cancelButtonText: '取消' 
    //              }).then(action => { 
    //                if (action == 'confirm') {
    //                 that.$router.push("/combo/buyCombo");
    //                }
    //              }).catch(err => { 
    //                if (err == 'cancel') {
    //                 console.log('取消');
    //                } 
    //              });
    //       }else{
    //         that.$toast(response.data.msg);
    //         return;
    //       }
    //       },function(error){
    //         console.log(error);
    //   });
      //this.temp = this.$route.query.temp;
    },
    showSginContract:function(){
      var that = this;
      that.$http.post(
          domain("_showcontract"),
          {
            'contractId':this.cid
          }
      )
      .then(function(response){
        console.log(response)
        if(response.data.code=='0'){
          var resData = response.body.data;
          that.dataList=resData.imgList;
          var mysigns = resData.mysigns;
          if(mysigns.length>0){
          	that.defaultSignId=mysigns[0].registerSignId;
          }
          for(var i=0;i<mysigns.length;i++){
            if(mysigns[i].isDefault=='1'){
              that.defaultSignId = mysigns[i].registerSignId;
              break;
            }
          }
          that.registerType=response.body.data.registerType;
          that.rooturl = domain("_rooturl")+"/";
          that.dataList.map(function(item,index){
            item.signed = false;
            item.signPage = "sign"+(index+1);
          });
          that.pushList = [];
          for(var i=0;i<this.dataList.length;i++){
            /*var row = {'pageIdx':i,'width':180,'pointX':147*1.5,'pointY':254*1.5};*/
            var row = {'pageIdx':i,'width':180,'pointX':0,'pointY':0};
            that.pushList.push(row);
          }
          // 手写签名
          var regsw = that.$route.query.regsw;
          var signatureList = that.$route.query.signatureList;
          signatureList = eval(signatureList);
          if(regsw != null && regsw != "" && typeof(regsw) != "undefined"){
            that.registerSignId=regsw;
            that.currentPage = this.$route.query.cpage;
            that.signatureImg = domain("_rooturl")+"/files/contract/registerSignService/"+that.registerSignId;
            for(var k=0;k<signatureList.length;k++){
              that.dataList[k].signed = signatureList[k].signed;
            }
            that.pushList = eval(that.$route.query.pushList);
            for(var k=0;k<that.pushList.length;k++){
              that.pushList[k].registerSignId = that.registerSignId;
              Vue.set(that.pushList, k, that.pushList[k]);
            }
            that.dataList[that.currentPage-1].signed = true;
            Vue.set(that.dataList, that.currentPage-1, that.dataList[that.currentPage-1]);
          }
          // 手写签名end
        }else if(response.body.code=='999'){
          	that.$router.push("/main");
        }else{
          that.$toast(response.data.msg);
        }
          },function(error){
            console.log(error);
      })
    },
    showSgincgx:function(){
      var that = this;
      that.$http.post(
          domain("_initiate"),
          {
            'contractId':this.cid
          }
      )
      .then(function(response){
        console.log(response)
          if(response.data.code=='0'){
            var resData = response.data.data;
            that.dataList=resData.imgList;
            var mysigns = resData.mysigns;
            if(mysigns.length>0){
          		that.defaultSignId=mysigns[0].registerSignId;
            }
            for(var i=0;i<mysigns.length;i++){
              if(mysigns[i].isDefault=='1'){
                that.defaultSignId = mysigns[i].registerSignId;
                break;
              }
            }
            that.registerType=response.data.data.registerType;
            that.rooturl = domain("_rooturl")+"/";
            that.dataList.map(function(item,index){
              item.signed = false;
              item.signPage = "sign"+(index+1);
            });
            that.pushList = [];
            for(var i=0;i<that.dataList.length;i++){
              var row = {'pageIdx':i,'width':180,'pointX':0,'pointY':0};
              that.pushList.push(row);
            }
            // 手写签名
            var regsw = that.$route.query.regsw;
            var signatureList = that.$route.query.signatureList;
            signatureList = eval(signatureList);
            if(regsw != null && regsw != "" && typeof(regsw) != "undefined"){
              that.registerSignId=regsw;
              that.currentPage = that.$route.query.cpage;
              that.signatureImg = domain("_rooturl")+"/files/contract/registerSignService/"+that.registerSignId;
              that.pushList = eval(that.$route.query.pushList);
              for(var k=0;k<that.pushList.length;k++){
                that.pushList[k].registerSignId = that.registerSignId;
              }
              for(var k=0;k<signatureList.length;k++){
                that.dataList[k].signed = signatureList[k].signed;
              }
              that.dataList[that.currentPage-1].signed = true;
              Vue.set(that.dataList, that.currentPage-1, that.dataList[that.currentPage-1]);
            }
            // 手写签名end
          }else if(response.data.code=='999'){
          	that.$router.push("/main");
          }else if(response.data.code == '5'){
                 MessageBox.confirm('', { 
                 message: '套餐余额不足，请先购买套餐后进行签署！', 
                 title: '提示', 
                 confirmButtonText: '去购买', 
                 cancelButtonText: '取消' 
                 }).then(action => { 
                   if (action == 'confirm') {
                    that.$router.push("/combo/buyCombo");
                   }
                 }).catch(err => { 
                   if (err == 'cancel') {
                    console.log('取消');
                   } 
                 });
          }else{
            that.$toast(response.data.msg);
          }
        },function(error){
          console.log(error);
      })
    },
    pagePrev:function(){
      this.end();
      if(this.currentPage == 1){
      }else{
        this.currentPage--;
      }
    },
    pageNext:function(){
      this.end();
      if(this.currentPage == this.dataList.length){
      }else{
        this.currentPage++;
      }
    },
    repush: function(){
      	for(var i=0;i<this.dataList.length;i++){
	      	if(!this.dataList[i].signed){
	      	  var row = {'pageIdx':i,'width':180,'pointX':0,'pointY':0};
	          this.pushList.splice(i,0,row);
	        }
    	}
    },
    push: function(){
      var psize = this.pushList.length;
      var delsize = 0;
      for(var i=0;i<psize;i++){
        if(!this.dataList[i].signed){
          this.pushList.splice(i-delsize,1);
          delsize++;
        }
      }
    },
    saveSign: function({ certPlatformType, userCertificateAgreementId, certificateSerialNumber } = {}){
      var that = this;
      this.end();
      this.push();
      var jsonStr = JSON.stringify(that.pushList);
      Indicator.open('加载中...');
      that.$http.post(
          domain("_signing"),
          // {
          //   'temp':that.temp,
          //   'key':that.cid,
          //   'jsonStr':jsonStr,
          //   'signpw':$.md5(signpw),
          //   'certPlatformType': certPlatformType,
          //   policyReadAt: policyReadAt
          // }
          {
            'key':that.cid,
            'jsonStr':jsonStr,
            certPlatformType,
            userCertificateAgreementId,
            certificateSerialNumber,
          }
      )
      .then(function(response){
        console.log(response)
          Indicator.close();
          if(response.data.code==0){
            this.$TsaSignPassword.hide()
             that.$toast('签署成功');
             that.fileType = response.data.data.fileType;
             if(that.fileType == 1){
                that.$router.replace({name: 'addsigner', query:{'cid': that.cid}});
             }else{
                that.$router.push("/main");
             }
          } else if (response.data.code === '1') {
            that.$toast(response.data.msg);
          } else if (response.data.code === '3') {
            that.$toast('签署失败，请重新签署');
          } else if(response.data.code == '5'){
            this.$TsaSignPassword.hide()
                 MessageBox.confirm('', { 
                 message: '套餐余额不足，请先购买套餐后进行签署！', 
                 title: '提示', 
                 confirmButtonText: '去购买', 
                 cancelButtonText: '取消' 
                 }).then(action => { 
                   if (action == 'confirm') {
                    that.$router.push("/combo/buyCombo");
                   }
                 }).catch(err => { 
                   if (err == 'cancel') {
                    console.log('取消');
                   } 
                 });
          } else{
             that.$toast(response.data.msg);
             this.repush();
          }
        },function(error){
          console.log(error);
          Indicator.close();
          this.repush();
      })
    },
    next() {
      if(['1', '7'].indexOf(this.approveStatus) === -1){
        this.$toast('您还没有实名认证，请先实名认证');
        return
      }
      var that = this;
      this.issign = false;
      for(var j=0;j<this.dataList.length;j++) {
        if(this.dataList[j].signed){
          this.issign = true;
          break;
        }
      }
      if(this.issign){
        this.$TsaLoading.show()
        signFlowInitApi({
          contractId: this.cid
        }).then((res) => {
          if (res.code == '0') {
            signCheckStatusApi({
              // 用户类型：1=个人, 2=企业
              userType: this.approveStatus == '1' ? '1' : '2',
            }).then((res1) => {
              // nextStep
              this.$TsaLoading.hide()
              // 个人已经实名认证了 要从res中取值
              let nextStep = res1.data.nextStep
              let verificationId = res1.data.verificationId
              let signSessionId = res.data.signSessionId
              // 需要个人核验
              if (nextStep == 'PERSONAL_VERIFICATION') {
                // 需要经办人核验（企业） => 引导到个人核验流程
                this.personProcess({
                  signSessionId,
                })
              } else if (nextStep == 'OPERATOR_VERIFICATION') {
                // 需要经办人核验（企业） => 引导到企业经办人核验流程
                this.companyProcess({
                  signSessionId,
                })
              } else if (nextStep == 'AGREEMENT') {
                // 核验已通过，跳过核验 => 引导到协议页面
                // 走到这里一定是个人
                this.$TsaLoading.hide()
                this.$TsaDigitalCertificateAgreement.show({
                  contractId: this.cid,
                  signSessionId,
                  verificationId,
                  onConfirm: ({hasPassword, userCertificateAgreementId, certPlatformType } = {}) => {
                    // 是否已设置密码
                    if (hasPassword) {
                      // 直接显示签署密码
                      this.setPasswordCommon({signSessionId, verificationId, userCertificateAgreementId, certPlatformType})
                    } else {
                      // 设置签署密码
                      this.$TsaSetOrForgetPassword.show({
                        type: 'set', // 设置密码
                        contractId: this.cid,
                        signSessionId,
                        verificationId,
                        onConfirm: ({} = {}) => {
                          this.setPasswordCommon({signSessionId, verificationId, userCertificateAgreementId, certPlatformType})
                        }
                      })
                    }
                  }
                })
              } else {
                this.$toast('系统异常')
              }
            }).catch((err) => {
              this.$TsaLoading.hide()
            })
          } else {
            this.$TsaLoading.hide()
            // toast由拦截器处理
          }
        }).catch((err) => {
          this.$TsaLoading.hide()
        })
      }else{
        that.$toast('请先盖章');
        return;
      }
    },
    // 个人流程
    personProcess ({ signSessionId } = {}) {
      this.$TsaPersonRealNameInfoVerify.show({
        contractId: this.cid,
        signSessionId,
        onConfirm: ({ verificationId} = {}) => {
          console.log(verificationId)
          this.$TsaLoading.hide()
          this.$TsaDigitalCertificateAgreement.show({
            contractId: this.cid,
            signSessionId,
            verificationId,
            onConfirm: ({hasPassword, userCertificateAgreementId, certPlatformType } = {}) => {
              // 是否已设置密码
              if (hasPassword) {
                // 直接显示签署密码
                this.setPasswordCommon({signSessionId, verificationId, userCertificateAgreementId, certPlatformType})
              } else {
                // 设置签署密码
                this.$TsaSetOrForgetPassword.show({
                  type: 'set', // 设置密码
                  contractId: this.cid,
                  signSessionId,
                  verificationId,
                  onConfirm: ({} = {}) => {
                    this.setPasswordCommon({signSessionId, verificationId, userCertificateAgreementId, certPlatformType})
                  }
                })
              }
            }
          })
        }
      })
    },
    // 企业流程
    companyProcess ({ signSessionId } = {}) {
      console.log({
        cid: this.cid
      })
      this.$TsaHandlerInfoVerify.show({
        contractId: this.cid,
        signSessionId,
        // 经办人姓名 经办人身份证号 经办人手机号
        onConfirm: ({ operatorName, operatorIdCard, operatorPhone, nextStep, tempVerificationId, verificationId } = {}) => {
          if (nextStep == 'ENTERPRISE_VERIFICATION') {
            // 无有效企业记录，需新核验 
            this.$TsaHandlerVerifySuccess.show({
              onConfirm: () => {
                // 企业信息核验
                this.$TsaCompanyRealNameInfoVerify.show({
                  verificationId: tempVerificationId,
                  contractId: this.cid,
                  signSessionId,
                  operatorName,
                  operatorIdCard,
                  operatorPhone,
                  // 【企业用户】统一社会信用代码  【企业用户】企业名称  【企业用户】法定代表人姓名
                  onConfirm: ({ enterpriseCreditCode, enterpriseName, legalRepName, verificationId } = {}) => {
                    // 同意授权书
                    this.$TsaAuthorizationLetter.show({
                      contractId: this.cid,
                      signSessionId,
                      operatorName,
                      operatorIdCard,
                      operatorPhone,
                      enterpriseName,
                      enterpriseCreditCode,
                      legalRepName,
                      onConfirm: ({ ossKey } = {}) => {
                        // 授权验证码弹窗
                        this.$TsaAuthorizationCode.show({
                          contractId: this.cid,
                          verificationId,
                          signSessionId,
                          authorizationOssKey: ossKey,
                          onConfirm: ({ verificationId } = {}) => {
                            this.$TsaDigitalCertificateAgreement.show({
                              contractId: this.cid,
                              signSessionId,
                              verificationId,
                              onConfirm: ({hasPassword, userCertificateAgreementId, certPlatformType } = {}) => {
                                // 是否已设置密码
                                if (hasPassword) {
                                  // 直接显示签署密码
                                  this.setPasswordCommon({signSessionId, verificationId, userCertificateAgreementId, certPlatformType})
                                } else {
                                  // 设置签署密码
                                  this.$TsaSetOrForgetPassword.show({
                                    type: 'set', // 设置密码
                                    contractId: this.cid,
                                    signSessionId,
                                    verificationId,
                                    onConfirm: ({} = {}) => {
                                      this.setPasswordCommon({signSessionId, verificationId, userCertificateAgreementId, certPlatformType})
                                    }
                                  })
                                }
                              }
                            })
                          }
                        })
                      }
                    })
                  }
                })
              }
            })
          } else if (nextStep === 'AGREEMENT') {
            // 有未过期的企业核验记录，复用旧企业信息
            this.$TsaDigitalCertificateAgreement.show({
              contractId: this.cid,
              signSessionId,
              verificationId,
              onConfirm: ({hasPassword, userCertificateAgreementId, certPlatformType } = {}) => {
                // 是否已设置密码
                if (hasPassword) {
                  // 直接显示签署密码
                  this.setPasswordCommon({signSessionId, verificationId, userCertificateAgreementId, certPlatformType})
                } else {
                  // 设置签署密码
                  this.$TsaSetOrForgetPassword.show({
                    type: 'set', // 设置密码
                    contractId: this.cid,
                    signSessionId,
                    verificationId,
                    onConfirm: ({} = {}) => {
                      this.setPasswordCommon({signSessionId, verificationId, userCertificateAgreementId, certPlatformType})
                    }
                  })
                }
              }
            })
          } else {
            this.$toast('系统异常')
          }
        }
      })
    },
    // 设置签署密码
    setPasswordCommon ({ signSessionId, verificationId, userCertificateAgreementId, certPlatformType } = {}) {
      this.$TsaSignPasswordV2.show({
        contractId: this.cid,
        signSessionId,
        verificationId,
        onForget: () => {
          // 设置或忘记密码
          this.$TsaSetOrForgetPassword.show({
            type: 'forget', // 忘记密码
            contractId: this.cid,
            signSessionId,
            verificationId,
            onClose: () => {
              this.setPasswordCommon({signSessionId, verificationId, userCertificateAgreementId, certPlatformType})
            },
            onConfirm: ({} = {}) => {
              this.setPasswordCommon({signSessionId, verificationId, userCertificateAgreementId, certPlatformType})
            }
          })
        },
        onConfirm: ({} = {}) => {
          // 申请证书
          this.$TsaLoading.show()
          signCertificateApplyApi({
            contractId: this.cid,
            signSessionId,
            verificationId,
            userCertificateAgreementId
          }).then((res) => {
            this.$TsaLoading.hide()
            if (res.code == '0') {
              let { certificateSerialNumber } = res.data || {}
              this.saveSign({ certPlatformType, userCertificateAgreementId, certificateSerialNumber });
            }
            // 调用接口
          }).catch((err) => {
            this.$TsaLoading.hide()
          })
        },
      })
    },
    closeSignature:function(item,index){
      item.signed = false;
      Vue.set(this.dataList, index, item);
    },
    addSignature: function(item,index){
      this.$http.post(
          domain("_judgezhang"),
          {}
      )
      .then(function(response){
          if(response.data.code==0){
          	  this.registerSignId=this.defaultSignId;
		      this.signatureImg = domain("_rooturl")+"/files/contract/registerSignService/"+this.registerSignId;
		      item.signed = true;
		      this.pushList[this.currentPage-1].registerSignId = this.registerSignId;
		      Vue.set(this.pushList, this.currentPage-1, this.pushList[this.currentPage-1]);
		      Vue.set(this.dataList, index, item);
          }else if(response.data.code==1){
             this.$toast(response.data.msg);
          }else{
          	this.$toast("系统错误");
          }
      },function(error){
          console.log(error);
          this.repush();
      })

    },
    toSignature:function(){
      this.$router.push({name: 'signature', query:{'cid': this.cid,'cpage': this.currentPage,'seenPage': 2,'signatureList':JSON.stringify(this.dataList),'pushList':JSON.stringify(this.pushList)}});
    },
      down:function(){
          var signature = document.getElementById("signaturesign"+this.currentPage);
          var signcontract = document.getElementById("sign"+this.currentPage);
          this.flag = true;
          var touch;
          if(event.touches){
              touch = event.touches[0];
          }else {
              touch = event;
          }
          this.cur = {x:touch.clientX, y:touch.clientY};
          this.dx = signature.offsetLeft+50;
          this.dy = signature.offsetTop+85;
          this.boxX = signcontract.offsetLeft+signcontract.clientWidth-signature.clientWidth;
          this.boxY = signcontract.offsetTop+signcontract.clientHeight-signature.clientHeight;
      },
      move:function(){
          var signature = document.getElementById("signaturesign"+this.currentPage);
          var signcontract = document.getElementById("sign"+this.currentPage);
          if(this.flag){
              var touch ;
              if(event.touches){
                  touch = event.touches[0];
              }else {
                  touch = event;
              }
              this.x = this.dx+touch.clientX - this.cur.x;
              this.y = this.dy+touch.clientY - this.cur.y;
              signature.style.left = this.x+"px";
              signature.style.top = this.y +"px";
              if(signature.offsetLeft<signcontract.offsetLeft){
                  signature.style.left = 50+"px";
              }else if(signature.offsetLeft>this.boxX){
                  signature.style.left = this.boxX+50+'px';
              }
              if(signature.offsetTop<signcontract.offsetTop-61){
                  signature.style.top=85-61+"px";
              }else if(signature.offsetTop>this.boxY+8){
                  signature.style.top = this.boxY+85+8+'px';
              }
          }
      },
      end:function(){
          this.flag = false;
          var signature = document.getElementById("signaturesign"+this.currentPage);
          var signcontract = document.getElementById("sign"+this.currentPage);
          this.pushList[this.currentPage-1].pointX = signature.offsetLeft*1.5;
          this.pushList[this.currentPage-1].pointY =
          signcontract.clientHeight*1.5 - signature.offsetTop*1.5-61*1.5;
          this.pushList[this.currentPage-1].registerSignId = this.registerSignId;
          Vue.set(this.pushList, this.currentPage-1, this.pushList[this.currentPage-1]);
      },
      vtouchstart:function(){
        event.preventDefault();
        this.down();
      },
      vtouchmove:function(){
        event.preventDefault();
        this.move();
      },
      vtouchend:function(){
        event.preventDefault();
        this.end();
      },
      goback: function () {
        history.go(-1); //后退1页
      },
      backhome: function () {
        this.$router.push('/main');
      }
  },
  components:{
     cheader
  },
  beforeDestroy () {
    this.$TsaAgreement.hide()
    this.$TsaSignPassword.hide()
    this.$TsaLoading.hide()
    this.$TsaDigitalCertificateAgreement.hide()
    this.$TsaSetOrForgetPassword.hide()
    this.$TsaPersonRealNameInfoVerify.hide()
    this.$TsaHandlerInfoVerify.hide()
    this.$TsaHandlerVerifySuccess.hide()
    this.$TsaCompanyRealNameInfoVerify.hide()
    this.$TsaAuthorizationLetter.hide()
    this.$TsaAuthorizationCode.hide()
    this.$TsaSignPasswordV2.hide()
    this.$TsaEnvironmentCheck.hide()
  }
}
</script>
<style>
.sign .mint-header{
  position: fixed;
  width: 100%;
  z-index: 2;
}
.sign .content{
  padding: 50px 0 60px;
}
.signbottom{
  width:100%;
  height:56px;
  background-color: #f0f0f0;
  border-top: 1px solid #d7d7d7;
  bottom: 0;
  position: fixed;
  z-index: 2;
  display: flex;
}
.signflex{
  padding: 7px 0;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: center;
}
.signflex img{
  width:20px;
}
.signflex .signimg{
  width:15px;
}
.signflex div{
  color: #1f74d8;
  font-size: 0.8rem;
}
.signcontract{
 /*width:476px;*/
}
.pagestyle{
  width:42px;
  height:24px;
  line-height:24px;
  background-color: #d2d2d2;
  filter:alpha(opacity=80); /* IE */
  -moz-opacity:0.8; /* 老版Mozilla */
  -khtml-opacity:0.8; /* 老版Safari */
  opacity: 0.8; /* 支持opacity的浏览器*/
  border-radius: 4px;
  -ms-border-radius: 4px;
  -moz-border-radius: 4px;
  -o-border-radius: 4px;
  -webkit-border-radius: 4px;
  position: fixed;
  z-index: 2;
  text-align: center;
  color: #ffffff;
  right:5px;
  margin-top: 10px;
}
.unipage{
  width: 30px;
  background: #cccccc;
  right: 0;
  top: 50%;
  margin-top: -54px;
  position: fixed;
  z-index: 2;
  border-radius: 5px 0 0 5px;
  opacity: 0.6;
}
.unipage a{
  width: 100%;
  height: 32px;
  display: inline-block;
  color: #fff;
  text-decoration: none;
  text-align: center;
  background-size: 60% auto;
}
.unipage a em{
  margin-top:10px;
  text-indent: -9999px;
  display: block;
  background-size: 18px auto;
  font-style: normal;
  font-size: 11px;
  letter-spacing: -1px;
  margin: 0 auto;
}
.unipage a .one{
  margin-top:10px;
  width: 15px;
  height: 15px;
  background: url(/static/img/contract/down.png) no-repeat center;
}
.unipage a .four{
  margin-top: 10px;
  width: 15px;
  height: 15px;
  background: url(/static/img/contract/up.png) no-repeat center;
}
.abscont{
  position: relative;
}
.sign .signature{
  width:120px;
  height:190px;
  position: absolute;
  text-align: center;
  /*top:150px;
  left:50%;*/
  top:24px;
  left:50px;
  margin:-85px 0 0 -50px;
}
.deldiv{
  width:50px;
  height: 50px;
  margin: 0 auto;
  background-color: #202020;
  filter:alpha(opacity=60); /* IE */
  -moz-opacity:0.6; /* 老版Mozilla */
  -khtml-opacity:0.6; /* 老版Safari */
  opacity: 0.6; /* 支持opacity的浏览器*/
  border-radius: 4px;
  -ms-border-radius: 4px;
  -moz-border-radius: 4px;
  -o-border-radius: 4px;
  -webkit-border-radius: 4px;
}
.deldiv img{
  width:30px;
  margin-top:10px;
}
.sjimg{
  width:10px;
  margin-bottom: 8px;
}
.signdiv{
  width: 120px;
  height:120px;
  margin: 0 auto;
  margin-top: -8px;
  border: 2px dashed #1f74d8;
}
.mint-msgbox-input input{
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  color:transparent;
  text-shadow: 0 0 0 #999;
}
</style>



// WEBPACK FOOTER //
// src/module/contract/Sign.vue